export const openFileInNewTab = (url: string) => {
  const link = document.createElement("a");
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  link.href = url;
  link.click();
};
